var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4005 20.2813H25.6001V22.6123C26.3491 21.2717 28.2699 20.0671 31.1553 20.0671C36.6867 20.0671 37.9999 22.7358 37.9999 27.6322V36.7004H32.3999V28.7473C32.3999 25.9589 31.6509 24.3864 29.7441 24.3864C27.0995 24.3864 26.0005 26.0811 26.0005 28.746V36.7004H20.4005V20.2813Z",
    fill: "#E3E4E6",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7979 36.4862H16.3979V20.0671H10.7979V36.4862Z",
    fill: "#E3E4E6",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2002 14.713C17.2004 15.1354 17.1073 15.5537 16.9263 15.9435C16.7454 16.3333 16.4801 16.6868 16.146 16.9835C15.469 17.5891 14.5525 17.9281 13.598 17.926C12.6451 17.9254 11.7308 17.5873 11.0528 16.9848C10.7199 16.6871 10.4555 16.3331 10.2749 15.9433C10.0942 15.5535 10.0008 15.1354 10 14.713C10 13.86 10.378 13.0435 11.0542 12.4412C11.7316 11.8379 12.6463 11.4996 13.5994 11.5C14.5542 11.5 15.4698 11.8389 16.146 12.4412C16.8208 13.0435 17.2002 13.86 17.2002 14.713Z",
    fill: "#E3E4E6",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.015d9e93a6fc8652c52849b067083d64.svg";
export { ForwardRef as ReactComponent };